<template>
    <div class="card">
        <div class="title">{{$t('基本信息')}}</div>
        <div class="basic-inf">
            <div class="inf-pack"
                 id="step_authent">
                <div class="img">
                    <img src="@/assets/images/console/default-user.png">
                </div>
                <div>
                    <b class="welcome">{{$t('您好')}}！{{basicInf.account}}</b>
                    <p class="authent">{{$t('认证状态')}}：<span v-html="authentStatus"
                              @click="handleAuthent"></span></p>
                    <!-- <span class="time">{{$t('最后登录')}}：{{basicInf.lastLoginTime}}</span> -->
                    <ul class="more">
                        <li @click="hasPermission('CC01')&&$router.push('order')">{{$t('我的订单')}}</li>
                        <li @click="hasPermission('CC03')&&$router.push('bill')">{{$t('我的账单')}}</li>
                        <li @click="hasPermission('CC07')&&$router.push('deals')">{{$t('收支明细')}}</li>
                    </ul>
                </div>
            </div>
            <ul class="num-pack"
                v-if="statistics.length>0">
                <li @click="hasPermission('CB01')&&$router.push('/mgt/renew')">
                    <b>{{$isNullOrEmpty(statistics[0].expireCount)?'--':statistics[0].expireCount}}</b>
                    <span :title="$t('资源即将到期(30天内)')"
                          class="rc-ellipsis">{{$t('资源即将到期(30天内)')}}</span>
                </li>
                <li @click="hasPermission('CC01')&&$router.push('/mgt/order')">
                    <b>{{$isNullOrEmpty(statistics[0].orderCount)?'--':statistics[0].orderCount}}</b>
                    <span :title="$t('订购资源待开通')"
                          class="rc-ellipsis">{{$t('订购资源待开通')}}</span>
                </li>
                <li @click="hasPermission('CD01')&&$router.push('/mgt/workorder')">
                    <b>{{$isNullOrEmpty(statistics[0].workOrderCount)? '--':statistics[0].workOrderCount}}</b>
                    <span :title="$t('工单待处理')"
                          class="rc-ellipsis">{{$t('工单待处理')}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { authentMaps } from '@/service/const.js'
export default {
    name: 'individualDashboard',
    // props: ['basicInf', 'statistics'],
    props: {
        basicInf: {
            type: Object
        },
        statistics: {
            type: Array
        }
    },
    components: {},
    data () {
        return {
            authType: this.$store.state.user.currentUser.info.authType
        }
    },
    computed: {
        authentStatus () {
            const authentStatusUser = this.$store.state.user.currentUser.info.authentStatus
            const { certificationStatus } = this.$store.state.user.currentOrg
            // 如果企业认证开始了，就展示企业认证的状态，否则展示个人认证的状态
            const authentStatus = this.authType === 'user' ? authentStatusUser : certificationStatus
            const text = this.$t(authentMaps[authentStatus])
            return `<span style="color: ${this.getColor(authentStatus)}">${text}</span>`
        }
    },
    methods: {
        handleAuthent () {
            // const { certificationStatus } = this.$store.state.user.currentOrg
            if (this.authType === 'user') {
                this.$router.push({
                    path: '/mgt/authent',
                    query: {
                        id: this.$store.state.user.currentUser.info.userSid
                    }
                })
            } else {
                this.$router.push({
                    path: '/mgt/authent/company'
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.basic-inf {
    display: flex;
    padding: 10px 15px;
    height: 120px;
    .inf-pack {
        width: 300px;
        display: flex;
        .img {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            margin-left: 8px;
            margin-right: 15px;
            border: 1px solid #e9e9e9;
            img {
                width: 100%;
                border-radius: 50%;
            }
        }
        .welcome {
            display: block;
            line-height: 27px;
        }
        .authent {
            line-height: 27px;
            color: #808080;
            span {
                cursor: pointer;
                &:hover {
                    color: #ff6a01;
                }
            }
        }
        .time {
            font-size: 12px;
            color: #808080;
        }
        .more {
            display: flex;
            margin-top: 5px;
            font-size: 12px;
            li {
                cursor: pointer;
                &:hover {
                    color: #ff6a01;
                }
                &:after {
                    content: '';
                    display: inline-block;
                    width: 1px;
                    height: 10px;
                    background-color: #e9e9e9;
                    margin: 0 12px;
                }
                &:last-child:after {
                    display: none;
                }
            }
        }
    }
    .num-pack {
        // flex-grow: 1;
        // display: flex;
        justify-content: space-between;
        font-size: 12px;
        width: calc(~'100% - 300px');
        li {
            float: left;
            width: 33.3%;
            padding: 0 1.5%;
            text-align: center;
            cursor: pointer;
            &:hover {
                color: #ff6a01;
            }
            b {
                display: block;
                font-size: 20px;
                line-height: 58px;
            }
            span {
                white-space: nowrap;
                display: block;
                width: 100%;
            }
        }
    }
}
</style>
